export function veiculosInRequest(params = {}) {
  return {
    type: '@locomotiva/VEICULOS_IN_REQUEST',
    payload: { params },
  };
}

export function findVeiculo(idveiculo) {
  return {
    type: '@locomotiva/FIND_VEICULO',
    payload: { idveiculo },
  };
}

export function failedRequest() {
  return {
    type: '@locomotiva/FAILED_REQUEST',
  };
}

export function deleteVeiculo(idveiculo, params) {
  return {
    type: '@locomotiva/DELETE_VEICULO',
    payload: { idveiculo, params },
  };
}

export function updateVeiculo(veiculo, params) {
  return {
    type: '@locomotiva/UPDATE_VEICULO',
    payload: { veiculo, params },
  };
}

export function storeVeiculo(veiculo, params) {
  return {
    type: '@locomotiva/STORE_VEICULO',
    payload: { veiculo, params },
  };
}

export function successInRequest(
  veiculos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@locomotiva/SUCCESS_IN_REQUEST',
    payload: { veiculos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(veiculo) {
  return {
    type: '@locomotiva/SUCCESS_REQUEST',
    payload: { veiculo },
  };
}

export function successRemove(params) {
  return {
    type: '@locomotiva/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@locomotiva/RECORD_FILTERING',
    payload: { params },
  };
}
